import script from "./GroupIconPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupIconPicker.vue?vue&type=script&setup=true&lang=js"

import "./GroupIconPicker.vue?vue&type=style&index=0&id=c22608a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c22608a0"]])

export default __exports__